<template>
  <div>
    <Header />
    <div class="payment-content flex-col md:flex-row">
      <div class="left-container box-border">
        <div
          class="shadow centered-flex"
          style="margin-bottom: 10px; height: auto"
        >
          <p class="p-4">
            If you have an outstanding balance you can use this page to make a
            payment. Payments made through your customer portal can be tracked
            using
            <router-link
              tag="a"
              style="color: blue"
              :to="{ name: 'PaymentHistory' }"
              >Payment History</router-link
            >
          </p>
        </div>
        <div class="flex-col sm:flex-row flex justify-between">
          <agreement-panel
            class="w-full sm:w-49"
            :mode="'stripped'"
            :user="user"
          />
          <BankDetails class="w-full sm:w-49" />
        </div>

        <div class="shadow address-holder" style="height: auto" v-if="!noPaymentRequired">
          <p style="color: red" v-if="error">{{ error }}</p>
          <div class="payment-amount">
            <p>
              Please enter the amount you'd like to pay (Must be between £{{
                Number(user.case.onlinePayMinValue).toFixed(2)
              }}
              and £{{ Number(user.case.onlinePayMaxValue).toFixed(2) }})
            </p>
            <span>
              £
              <input
                :disabled="disabled"
                min="1"
                type="number"
                v-model="amount"
              />
            </span>
          </div>
          <span class="primary-address">
            <input :disabled="disabled" id="cbxChangeDetails" type="checkbox" v-model="usePrimary" />
            <p style="display: inline">
              Use primary address as billing address
            </p>
          </span>
          <div class="billing-container">
            <h4 style="text-align: left; padding: 0; margin: 0">
              <b>Billing Address</b>
            </h4>
            <div class="row">
              <div class="column-1">
                <p>Line 1 (Flat/House number)(Required)</p>
              </div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ user.address.line1 }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="billingAddress.line1"
                />
              </div>
            </div>
            <div class="row">
              <div class="column-1">Line 2 (Street name)</div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ user.address.line2 }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="billingAddress.line2"                  
                />
              </div>
            </div>
            <div class="row">
              <div class="column-1">Town</div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ (user.address.line3 == "" ? user.address.line4 : user.address.line3)  }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="billingAddress.line3"
                />
              </div>
            </div>
            <!-- <div class="row">
              <div class="column-1">Country</div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ user.address.line4 }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="billingAddress.line4"
                />
              </div>
            </div> -->
            <div class="row">
              <div class="column-1">Postcode(Required)</div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ user.address.postcode }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="billingAddress.postcode"
                />
              </div>
            </div>
            <div class="row">
              <div class="column-1">Email(Required)</div>
              <div class="column-2">
                <p class="address-line" v-if="usePrimary">
                  {{ this.email_obj.detail }}
                </p>
                <input
                  v-if="!usePrimary"
                  class="edit-text"
                  :disabled="disabled"
                  type="text"
                  v-model="user_email"
                />
              </div>
            </div>
          </div>
          <button class="pay-button" @click="makePayment">
            {{ buttonText }}
          </button>
        </div>
         <div class="shadow address-holder" style="height: auto" v-else>
           <p>There is no outstanding balance to pay.</p>
         </div>
      </div>
      <div class="shadow payment-box mt-2 md:mt-0" v-if="!noPaymentRequired">
        <p class="h-full w-full flex items-center justify-center" v-if="this.$route.query.response">
          <PaymentErrorHandler :errorCode="this.$route.query.response" />
        </p>
        <template v-else>
          <input
            type="submit"
            id="payButtonId"
            value="Checkout Now"
            style="display: none"
          />
          <div v-if="!disabled" class="placeholder">
            <p>Payment box will appear here once you press "Make Payment"</p>
          </div>
          <div v-if="disabled" class="iframe-wrapper">
            <iframe
              id="targetIframe"
              frameborder="0"
              class="w-full full-height"
            ></iframe>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import RealexHpp from "@/scripts/rxp-hpp.js";
const PaymentErrorHandler = () => import("@/components/PaymentErrorHandler");
const Header = () => import("@/components/Header");
const AgreementPanel = () => import("@/components/AgreementDetailsPanel");
const BankDetails = () => import("@/components/BankDetails");

export default {
  name: "MakePayment",
  components: {
    PaymentErrorHandler,
    Header,
    AgreementPanel,
    BankDetails,
  },

  data() {
    return {
      res: "",
      usePrimary: true,
      disabled: false,
      amount: Number,
      user: Object,
      buttonText: "Make Payment",
      billingAddress: {},
      user_email : "",
      error: "",
    };
  },

  created() {
    this.user = this.$store.getters.user;
    this.email_obj = (this.user.contact.find(c => c.typeDescription === "Email Primary") == null ? Object.create(this.user.contact) : this.user.contact.find(c => c.typeDescription === "Email Primary"));    
    this.amount = this.user.arrears;
  },

  watch: {
    amount() {
      this.error = "";
    },
  },

  computed:{
    noPaymentRequired(){
      return this.$store.getters.user.case.balance <= 0;
    }
  },

  mounted() {
    this.$http
      .get("Payment/getURL")
      .then((res) => {
        RealexHpp.setHppUrl(res.data);
      })
      .catch(() => {
        RealexHpp.setHppUrl("https://pay.realexpayments.com/pay");
      });
    //PaymentHandler component relies on res to know what error/code to display on the page
    //If the url is loaded without a parameter clear res so it doesnt show an error when not required
    this.res = this.$route.query.response;
    if (!this.res) {
      this.res = null;
    }
  },

  methods: {
    async createLogItem(content, method, endpoint){

      var logDetails = {
          content: content,
          cse_id: this.$store.getters.user.case.id,
          method: method,
          endpoint: endpoint,
          origin: "Portal"
        };

      await this.$http
            .post("Log/CreateLogItem", logDetails, {
              "Content-Type": "application/json",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then(
              (res) => {
                //Don't do anything.
              },
              (error) => {
                //Most errors will be caught by the TokenCheck component, but just in case its expired this catches it
                if (error.message.includes("401")) {
                  localStorage.clear();
                  this.$router.push({ name: "Login" });
                }
              }
          );
      },
    async makePayment() {

      if(this.user_email == "" && this.buttonText == "Make Payment")
      {
        if(this.email_obj.detail == null)
        {
          this.disabled = false;
          this.buttonText = "Change Details";
          this.error = "Please add your email to make a payment";  
          document.getElementById("cbxChangeDetails").click();

          this.billingAddress.line1 = this.$store.getters.user.address.line1;
          this.billingAddress.line2 = this.$store.getters.user.address.line2;
          this.billingAddress.line3 = (this.$store.getters.user.address.line3 == "" ? (this.$store.getters.user.address.line4 == "" ? this.$store.getters.user.address.line5 : this.$store.getters.user.address.line4) : this.$store.getters.user.address.line3);
          this.billingAddress.postcode = this.$store.getters.user.address.postcode;

          return; 
        }
        else
        {
            this.user_email = this.email_obj.detail;
        }
      }    
      
      var email_changed = false;
      if(this.buttonText != "Make Payment")
      {
        if(this.user_email != "" && this.email_obj.detail == undefined)
        {
          //new email       
          email_changed = true;
        }

        if(this.user_email != this.email_obj.detail && this.email_obj.detail != null)
        {
          //update email
          email_changed = true;
        }

        var emailDetails = {
          Email: this.user_email,
          CaseID: this.$store.getters.user.case.id,
          PartyID: this.$store.getters.user.id,
        };

        if(email_changed)
        {
          this.error = "";
          await this.$http
            .post("Party/updatePartyEmail", emailDetails, {
              "Content-Type": "application/json",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then(
              (res) => {
                //Don't do anything.
              },
              (error) => {
                //Most errors will be caught by the TokenCheck component, but just in case its expired this catches it
                this.createLogItem(error, "Post", "Party/updatePartyEmail");
                if (error.message.includes("401")) {
                  localStorage.clear();
                  this.$router.push({ name: "Login" });
                }
              }
          );
        }
      }
      
      if (
        this.amount < this.user.case.onlinePayMinValue ||
        this.amount > this.user.case.onlinePayMaxValue ||
        !this.amount
      ) {
        this.error = "Please choose a payment amount within the accepted range";
        return;
      }      
      
      if (this.buttonText == "Change Details") {
        this.buttonText = "Make Payment";
        this.disabled = false;
      } else {
        if (
          !this.usePrimary &&
          (!this.billingAddress.line1 || !this.billingAddress.postcode)
        ) {
          if(!this.billingAddress.postcode) this.error = "Postcode is required"
          if(!this.billingAddress.line1) this.error = "Address line 1 is required"
          return;
        }

        let address = {
          Line1: !this.usePrimary
            ? this.billingAddress.line1
            : this.$store.getters.user.address.line1,
          Line2: !this.usePrimary
            ? this.billingAddress.line2
            : this.$store.getters.user.address.line2,
          Town: !this.usePrimary
            ? (this.billingAddress.line3 == "" ? (this.billingAddress.line4 == "" ? this.billingAddress.line5 : this.billingAddress.line4) : this.billingAddress.line3)
            : (this.$store.getters.user.address.line3 == "" ? (this.$store.getters.user.address.line4 == "" ? this.$store.getters.user.address.line5 : this.$store.getters.user.address.line4) : this.$store.getters.user.address.line3),
          Country: 826,
          PostCode: !this.usePrimary
            ? this.billingAddress.postcode
            : this.$store.getters.user.address.postcode,
        };

        var details = {
          Amount: parseFloat(this.amount),
          Address: address,
          Email: this.user_email,
          AgreementNumber: this.user.case.agreementNo,
        };
        this.disabled = true;
        this.buttonText = "Change Details";

        let pty = {
          agreementNo: this.user.case.agreementNo,
          jwt: localStorage.getItem("token"),
          caseId: this.$store.getters.user.case.id,
        };
        this.error = "";

        await this.$http
          .post("Payment/post", details, {
            "Content-Type": "application/json",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then(
            (res) => {
              //Used as a toggle to show/hide the iframe container and disable inputs once a payment object has been built
              //This uses a modified version of realex's hpp js file to send the payment response to the api instead of back to the page  
              console.log(res.data);
              RealexHpp.embedded.init(
                "payButtonId",
                "targetIframe",
                pty,
                JSON.parse(res.data)
              );
              //HPP requires you to click a button to initialise it, but the button can't have 2 click handlers, so this button is hidden & triggered programatically
              document.getElementById("payButtonId").click();
            },
            (error) => {
              this.createLogItem(error, "Post", "Payment/post");
              //Most errors will be caught by the TokenCheck component, but just in case its expired this catches it
              if (error.message.includes("401")) {
                localStorage.clear();
                this.$router.push({ name: "Login" });
              }
            }
          );
      }
    },    
  },
};
</script>

<style scoped>
.shadow {
	-webkit-box-shadow: 3px 2px 14px -1px #cccccc;
	-moz-box-shadow: 3px 2px 14px -1px #cccccc;
	box-shadow: 3px 2px 14px -1px #cccccc;
	background-color: white;
	border-bottom: 2px solid #41b3a3;
}

.centered-flex {
	display: flex;
	justify-content: center;
	align-items: center;
}

.payment-content {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	width: 98%;
	margin: 0 auto;
}

.payment-content .agreement {
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 5px;
}

.payment-content .agreement p {
	margin: 0;
	padding: 5px;
}

.payment-content .agreement h4 {
	padding: 0;
	margin: 0;
}

.payment-content .address-holder {
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.payment-content .address-holder button {
	font-family: "Roboto", sans-serif;
	text-transform: uppercase;
	outline: 0;
	background: #41b3a3;
	border: 0;
	padding: 15px;
	color: #ffffff;
	font-size: 14px;
	-webkit-transition: all 0.3 ease;
	transition: all 0.3 ease;
	cursor: pointer;
}

.payment-content .address-holder button:disabled {
	background-color: #5f5f5f;
}

.payment-content .address-holder .payment-amount {
	display: flex;
	justify-content: space-between;
}

.payment-content .address-holder .payment-amount input {
	padding: 2px;
	border: 1px solid #ccc;
	border-radius: 3px;
	margin-bottom: 10px;
	width: 50%;
	box-sizing: border-box;
	color: #2c3e50;
	font-size: 13px;
}

.payment-content .address-holder .payment-amount p {
	margin: 0;
	padding: 0;
}

.payment-content .iframe-wrapper {
	width: 450px;
	height: 600px;
}

.payment-content .payment-box {
	width: 100%;
	height: 600px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.payment-content .payment-box .placeholder {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 450px;
}

.payment-content .full-width {
	width: 450px;
}

.payment-content .full-height {
	height: 600px;
}

@media only screen and (min-width: 745px) {
	.payment-content .payment-box {
		width: 450px;
	}
}

.pay-button {
	align-self: flex-end;
	justify-self: flex-end;
}

.billing-container {
	width: calc(100% - 20px);
	margin: 10px 0 0 0;
	padding: 5px;
}

.billing-container input {
	width: 100%;
}

.billing-container p {
	margin: 0;
	padding: 1px 0;
	text-align: left;
}

.billing-container .address-line {
	font-size: 15px;
}

.left-container {
	width: 100%;
	margin-right: 10px;
}

.row {
	display: flex;
	width: 100%;
	margin: 10px 0;
}

.column-2 {
	flex: 48%;
	margin-right: 10px;
}

.column-1 {
	flex: 50%;
	text-align: left;
}

.edit-text {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

@responsive {
  .w-49 {
    width: 49%;
  }
}
</style>